import Optionable from "../utils/optionable";
import { observable } from "mobx";
import SourceType from "./sourceType";
import Enum from "./enum";

@Optionable((paygateRefundPaymentTemplate: PayGateToTransferRefundPaymentTemplate) => ({
  id: paygateRefundPaymentTemplate.id,
  label: paygateRefundPaymentTemplate.messageTemplate,
}))
export default class PayGateToTransferRefundPaymentTemplate extends Enum {
  /**
   * Payment template ID.
   * @example
   * 6625a162-9044-4146-b3d9-4acc4d441f6d
   */
  id!: string;

  /**
   * Bank account ID.
   * @example
   * 00b77518-76b6-476f-b3ea-5e0688e55651
   */
  @observable
  bankAccountId!: string;

  /**
   * Payment template code.
   * @example
   * D11
   */
  @observable
  code!: string;

  @observable
  sourceType!: SourceType;

  /**
   * Message template.
   * @example
   * Úhrada výzvy distributora - příchozí platba
   */
  @observable
  messageTemplate!: string;

  /**
   * Specific symbol.
   * @example
   * 115755
   */
  @observable
  specificSymbol?: number;

  /**
   * Constant symbol.
   */
  @observable
  constantSymbol?: number;
}
